import navaid from 'navaid';

export const router = navaid();
